{
  "name": "navizard-rtls",
  "version": "5.0.0.101",
  "description": "Bakelor Navizard RTLS",
  "author": "Bakelor Navizard Teams",
  "license": "http://bakelor.com",
  "private": true,
  "keywords": [
    "navizard",
    "rtls",
    "navizard-rtls",
    "rtls-live",
    "rtls-tracking"
  ],
  "scripts": {
    "ng": "ng",
    "patch:maplibre-runtime": "node scripts/patch-maplibre-runtime.js",
    "patch:leaflet-styleeditor-css": "node scripts/patch-leaflet-styleeditor-css.js",
    "screensaver:manifest": "node scripts/generate-screensaver-manifest.js",
    "prestart": "npm run screensaver:manifest && npm run patch:maplibre-runtime && npm run patch:leaflet-styleeditor-css",
    "start": "npm run cache:clean && ng serve --host 0.0.0.0 --port 4200 --allowed-hosts --hmr --live-reload --prebundle=false",
    "prelocal": "npm run screensaver:manifest && npm run patch:maplibre-runtime && npm run patch:leaflet-styleeditor-css",
    "local": "npm run cache:clean && ng serve --host 0.0.0.0 --port 4200 --allowed-hosts --configuration=local --hmr --live-reload --prebundle=false",
    "local:https": "npm run cache:clean && ng serve --host 0.0.0.0 --port 4200 --allowed-hosts --configuration=local --ssl --hmr --live-reload --prebundle=false",
    "local:stable": "npm run local",
    "local:stable:https": "npm run local:https",
    "preremote": "npm run patch:maplibre-runtime && npm run patch:leaflet-styleeditor-css",
    "remote": "npm run cache:clean && ng serve --host 0.0.0.0 --port 4200 --allowed-hosts --configuration=remote --hmr --live-reload --prebundle=false",
    "remote:https": "npm run cache:clean && ng serve --host 0.0.0.0 --port 4200 --allowed-hosts --configuration=remote --ssl --hmr --live-reload --prebundle=false",
    "remote:stable": "npm run remote",
    "remote:stable:https": "npm run remote:https",
    "cache:clean": "rm -rf .angular/cache",
    "wwwroot:clean": "node scripts/clean-wwwroot.mjs",
    "setup": "npm i --legacy-peer-deps --force",
    "postinstall": "node scripts/patch-maplibre-types.js && npm run patch:maplibre-runtime && node scripts/patch-fontawesome-sideeffects.js && npm run patch:leaflet-styleeditor-css",
    "prebuild": "npm run screensaver:manifest && npm run patch:maplibre-runtime && npm run patch:leaflet-styleeditor-css",
    "build": "npm run wwwroot:clean && ng build && npm run optimize:postbuild",
    "prewatch": "npm run patch:maplibre-runtime && npm run patch:leaflet-styleeditor-css",
    "watch": "npm run wwwroot:clean && ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "update": "npx npm-check-updates --upgrade --target minor",
    "rtls": "npm run wwwroot:clean && ng build --configuration production --aot --source-map=true && npm run optimize:postbuild",
    "rtls-zip": "npm run wwwroot:clean && ng build  --configuration production --aot --output-hashing none && npm run optimize:postbuild && npm run compress-rtls",
    "compress-rtls": "gzip-all \"../../Bakelor.RTLS.WebApi/wwwroot/*.{css,js}\" && rimraf ../../Bakelor.RTLS.WebApi/wwwroot/*.js && rimraf ../../Bakelor.RTLS.WebApi/wwwroot/*.css",
    "rtls-test": "npm run wwwroot:clean && ng build --watch --configuration production --source-map && npm run rtls-explore",
    "rtls-explore": "source-map-explorer dist/**/*.js",
    "rtls-clean": "rm -rf dist",
    "rtls-doc": "npx compodoc -p tsconfig.doc.json",
    "analyze": "npm run wwwroot:clean && ng build --configuration production --stats-json && webpack-bundle-analyzer dist/stats.json",
    "pwa:build": "npm run wwwroot:clean && ng build --configuration=local && npm run optimize:postbuild",
    "pwa:build:remote": "npm run wwwroot:clean && ng build --configuration=remote && npm run optimize:postbuild",
    "pwa:serve": "npx http-server ../../Bakelor.RTLS.WebApi/wwwroot -p 4200 -c-1",
    "pwa:dev": "npm run pwa:build && npm run pwa:serve",
    "pwa:dev:remote": "npm run pwa:build:remote && npm run pwa:serve",
    "scan:expression": "node ../../tools/expression-scan.mjs",
    "optimize:postbuild": "node scripts/postbuild-optimize-assets.mjs"
  },
  "dependencies": {
    "@angular-material-extensions/password-strength": "16.0.0",
    "@angular-slider/ngx-slider": "19.0.0",
    "@angular/animations": "22.0.0",
    "@angular/cdk": "22.0.0",
    "@angular/common": "22.0.0",
    "@angular/compiler": "22.0.0",
    "@angular/core": "22.0.0",
    "@angular/fire": "19.2.0",
    "@angular/forms": "22.0.0",
    "@angular/material": "22.0.0",
    "@angular/platform-browser": "22.0.0",
    "@angular/platform-browser-dynamic": "22.0.0",
    "@angular/router": "22.0.0",
    "@angular/service-worker": "22.0.0",
    "@asymmetrik/ngx-leaflet": "16.0.1",
    "@asymmetrik/ngx-leaflet-draw": "16.0.0",
    "@bakelor/iframe-bridge": "^9.0.0",
    "@deck.gl/core": "^8.9.36",
    "@deck.gl/extensions": "^8.9.36",
    "@deck.gl/geo-layers": "^8.9.36",
    "@deck.gl/layers": "^8.9.36",
    "@deck.gl/mesh-layers": "^8.9.36",
    "@fortawesome/angular-fontawesome": "0.13.0",
    "@fortawesome/fontawesome-svg-core": "git+http://together.teknopalas.com.tr:7990/scm/fa6/fontawesome-svg-core.git",
    "@fortawesome/pro-light-svg-icons": "git+http://together.teknopalas.com.tr:7990/scm/fa6/pro-light-svg-icons.git",
    "@fortawesome/pro-regular-svg-icons": "git+http://together.teknopalas.com.tr:7990/scm/fa6/pro-regular-svg-icons.git",
    "@fortawesome/pro-solid-svg-icons": "git+http://together.teknopalas.com.tr:7990/scm/fa6/pro-solid-svg-icons.git",
    "@geoman-io/leaflet-geoman-free": "^2.19.3",
    "@ionic/storage-angular": "^3.0.6",
    "@microsoft/signalr": "^10.0.0",
    "@ng-select/ng-option-highlight": "^21.8.2",
    "@ng-select/ng-select": "^21.8.2",
    "@ngneat/hotkeys": "^1.3.0",
    "@ngneat/until-destroy": "^9.2.3",
    "@ngrx/component": "19.2.1",
    "@ngx-translate/core": "^14.0.0",
    "@types/leaflet.markercluster": "^1.5.6",
    "@zxing/browser": "0.2.0",
    "@zxing/library": "0.23.0",
    "@zxing/ngx-scanner": "16.1.0",
    "angular-gridster2": "19.0.0",
    "angular-star-rating": "^6.0.0",
    "apexcharts": "3.54.1",
    "bakelor-map": "git+http://together.teknopalas.com.tr:7990/scm/bac/map-node-module.git#release/0.1.32",
    "class-transformer": "^0.5.1",
    "crypto-js": "4.2.0",
    "css-star-rating": "^1.3.1",
    "d3": "7.9.0",
    "devextreme": "25.2.7",
    "devextreme-angular": "25.2.7",
    "devextreme-aspnet-data-nojquery": "^3.0.0",
    "dynamics.js": "^1.1.5",
    "easy-pie-chart": "^2.1.7",
    "echarts": "^5.6.0",
    "exceljs": "^4.4.0",
    "file-saver": "^2.0.5",
    "firebase": "^9.23.0",
    "fireworks-js": "^2.10.8",
    "font-awesome-animation": "^1.1.1",
    "gsap": "^3.15.0",
    "highlight.js": "11.11.1",
    "jspdf": "^2.5.2",
    "jwt-decode": "^4.0.0",
    "leaflet": "^1.9.4",
    "leaflet-control-geocoder": "^2.4.0",
    "leaflet-draw": "^1.0.4",
    "leaflet-responsive-popup": "^1.0.0",
    "leaflet-sidebar-v2": "^3.2.3",
    "leaflet-styleeditor": "^0.1.21",
    "leaflet-swoopy": "^3.4.1",
    "leaflet.fullscreen": "^2.4.0",
    "leaflet.marker.slideto": "^0.3.0",
    "leaflet.markercluster": "^1.5.3",
    "leaflet.markercluster.placementstrategies": "^0.2.1",
    "linq-to-typescript": "^11.1.0",
    "lodash-es": "4.18.1",
    "maplibre-gl": "5.24.0",
    "marked": "^12.0.2",
    "monaco-editor": "^0.55.1",
    "mqtt": "^5.15.1",
    "ng-apexcharts": "1.17.1",
    "ng-lightquery": "^2.4.1",
    "ngx-color": "^8.0.3",
    "ngx-colors": "^3.6.0",
    "ngx-currency": "^2.5.3",
    "ngx-daterangepicker-material": "6.0.4",
    "ngx-echarts": "^14.0.0",
    "ngx-image-cropper": "^6.3.4",
    "ngx-logger": "^5.0.12",
    "ngx-mask": "20.0.3",
    "ngx-mat-select-search": "8.0.6",
    "ngx-monaco-editor-v2": "19.0.2",
    "ngx-scrollbar": "^10.0.1",
    "ngx-tippy-wrapper": "^5.0.2",
    "ngx-toastr": "^20.0.5",
    "ngx-translate-multi-http-loader": "^8.0.2",
    "ngx-ui-switch": "^14.1.0",
    "nouislider": "^15.8.1",
    "perfect-scrollbar": "1.5.6",
    "pluralize": "^8.0.0",
    "pouchdb": "^7.3.1",
    "pwa-asset-generator": "^6.4.0",
    "rxjs": "7.8.2",
    "sass": "^1.100.0",
    "three": "^0.184.0",
    "tilelayer-canvas": "^1.1.6",
    "tslib": "^2.8.1",
    "uuid": "^9.0.1",
    "vivus": "^0.4.6",
    "web-animations-js": "2.3.2",
    "zone.js": "0.16.2"
  },
  "devDependencies": {
    "@angular-eslint/eslint-plugin": "14.4.0",
    "@angular-eslint/eslint-plugin-template": "14.4.0",
    "@angular/build": "^22.0.0",
    "@angular/cli": "^22.0.0",
    "@angular/compiler-cli": "22.0.0",
    "@compodoc/compodoc": "^1.2.1",
    "@tailwindcss/aspect-ratio": "0.4.2",
    "@tailwindcss/forms": "^0.5.11",
    "@tailwindcss/line-clamp": "^0.4.4",
    "@tailwindcss/typography": "0.5.19",
    "@turf/turf": "^6.5.0",
    "@types/crypto-js": "4.2.2",
    "@types/d3": "7.4.3",
    "@types/d3-dispatch": "3.0.7",
    "@types/echarts": "^4.9.22",
    "@types/file-saver": "^2.0.7",
    "@types/highlight.js": "10.1.0",
    "@types/jasmine": "^4.6.5",
    "@types/leaflet": "^1.9.21",
    "@types/lodash": "4.17.24",
    "@types/lodash-es": "4.17.12",
    "@types/node": "^18.19.130",
    "chroma-js": "2.6.0",
    "dayjs": "^1.11.21",
    "eslint": "8.57.1",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "4.6.1",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.2.0",
    "lodash": "4.18.1",
    "ng-packagr": "^22.0.0",
    "postcss": "^8.5.15",
    "tailwindcss": "^3.4.19",
    "typescript": "6.0.3",
    "webpack": "^5.107.2",
    "webpack-bundle-analyzer": "^4.10.2"
  },
  "overrides": {
    "@types/d3-dispatch": "3.0.7"
  }
}
